<template>
  <div class="filter">
    <ul
      class="filter--slider"
      :style="`--current: ${current};`"
    >
      <FilterValueCard
        v-for="(val, index) in filterValues"
        :key="val.value"
        :filter="val"
        :selected="filterValue === val.value"
        :index="index"
        @selected="onSelected"
      />
    </ul>
  </div>
</template>
<script>
import FilterValueCard from '@/components/common/filter/slider/FilterValueCard.vue';
import mixin from '@/components/common/filter/FilterMixin.vue';

export default {
  components: {
    FilterValueCard,
  },
  mixins: [mixin],

  props: {
    // target: {
    //   type: Number,
    //   default: 0,
    // },
  },
  data() {
    return {
      current: 0,
    };
  },

  watch: {
    // current() {
    //   const value = this.filterValues[this.current].value;
    //   this.$store.commit('setFilterValue', value);
    //   // this.$emit('change', to);
    // },
    filterValue() {
      this.current = this.filterValues.findIndex(val => val.value === this.filterValue);
    },
    // target(to, from) {
    //   if (to < from) {
    //     this.decrease();
    //   } else {
    //     this.increase();
    //   }
    // },
  },

  methods: {
    onSelected(value) {
      this.$store.commit('setFilterValue', value);
    },
    // increase() {
    //   this.current = Math.min(this.current + 1, this.filterValues.length - 1);
    // },
    // decrease() {
    //   this.current = Math.max(this.current - 1, 0);
    // },
  },

};
</script>

<style lang="stylus">
:root{
  --container-width: $container-width;
}
</style>
<style lang="stylus">
  :root {
    --carousel-gap: 15px;
    --carousel-item-width: 241px;

    +desktop() {
      --carousel-gap: 15px;
      --carousel-item-width: 241px;
    }
  }
</style>

<style lang="stylus" scoped>
.filter {
  --leftMargin: 422px;
  margin: 0 0 0 var(--leftMargin);
  padding: 50px 0;
  overflow: hidden;
  pointer-events: auto;


  +mobile() {
    --leftMargin: 10px;
    & .filter--slider {
      transform: translateX(0);
    }
  }
}
</style>
<style scoped>
.filter .filter--slider {
    display: flex;
    justify-content: center;
    padding: 0;
    list-style: none;
    width: fit-content;
    gap: var(--carousel-gap);
    transition: transform 0.5s ease-out;
    perspective: 800px;
    perspective-origin: center left;
    --translateX: calc(calc(var(--current) * calc(-1 * calc(var(--carousel-item-width) + var(--carousel-gap)))) + var(--offset, 0px));
    --max-width: min(var(--container-width), calc(100vw - var(--app-gutter)));
    --slider-width: calc(var(--max-width) - var(--leftMargin));
    --maxTranslateX: min(0px, calc(calc(var(--slider-width) - 100%) - var(--carousel-gap)));
    --targetX: max(var(--translateX), var(--maxTranslateX));
    transform: translateX(var(--targetX));
  }

</style>
